module.exports = "/static/assets/10b8554664fe16cf03ad689126d24955.png";